import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {MaterialContext} from "#material/types/context"
import type {GraphNode, GraphNodeDefinition} from "@cm/graph-v3"
import {graphNode} from "@cm/graph-v3"
import {z} from "zod/v4-mini"
import type {SocketValueType} from "#material/sockets/socket-value-type"

export const materialConnectionDefinition = <Returns = any>() =>
    ({
        nodeClass: "MaterialConnection",
        validation: {
            parameters: z.strictObject({
                key: z.string(),
                value: graphNode(
                    MaterialNode<{
                        inputs: any
                        inputsExtensions: {}
                        settings: any
                        settingsExtensions: {}
                        outputs: {[Key: string]: SocketValueType}
                    }>,
                ),
            }),
            returns: z.any() as z.ZodMiniType<Returns>,
        },
    }) satisfies GraphNodeDefinition<Returns, {key: string; value: GraphNode<unknown, MaterialContext>}>
